import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar.jsx';

// Layout-Wrapper: Sidebar links, Hauptinhalt rechts.
export default function Layout() {
    return (
        <div className="layout">
            <Sidebar />
            <main className="main">
                <Outlet />
            </main>
        </div>
    );
}
